export default {
  bindings: {
    model: '='
  },
  controller: 'countrySelectorController',
  template: require('../views/country.selector.html')
};
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/components/country.selector.component.js